import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy pricing page removed from the new site — permanently redirect to the pricing page.
export const Route = createFileRoute("/hair-transplant-price")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/pricing/", location.searchStr), statusCode: 301 });
  },
});
